module.exports = __webpack_public_path__ + "prev.png?3c96e75012e190be2f2b10584eed2cbf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/layout/prev.png
// module id = 41
// module chunks = 0